import React, { Children } from 'react';
import { PageTitle } from '../components/PageTitle';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
export function PrivacyPolicy() {
  return <div className="bg-white min-h-screen" data-id="element-1382">
      <PageTitle title="Privacy Policy" canonical="/privacy" description="Privacy policy for Katalina Bock's professional portfolio website, detailing how your information is collected and used." keywords="privacy policy, data protection, personal information, GDPR, CCPA, cookies, Katalina Bock" data-id="element-1383" />
      <Helmet data-id="element-1384">
        <script type="application/ld+json" data-id="element-1385">
          {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Privacy Policy',
          description: "Privacy policy for Katalina Bock's professional portfolio website, detailing how your information is collected and used."
        })}
        </script>
      </Helmet>
      <section className="bg-gradient-to-r from-[#E0F5F8] to-[#F0FAFC] text-gray-900 py-12" data-id="element-1386">
        <div className="container mx-auto px-4" data-id="element-1387">
          <h1 className="text-4xl font-bold mb-4" data-id="element-1388">Privacy Policy</h1>
          <p className="text-base text-gray-700" data-id="element-1389">
            Last updated:{' '}
            {new Date().toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>
      </section>
      <section className="container mx-auto px-4 py-12" data-id="element-1390">
        <div className="max-w-4xl mx-auto prose prose-lg" data-id="element-1391">
          <h2 data-id="element-1392">1. Introduction</h2>
          <p data-id="element-1393">
            This Privacy Policy explains how Katalina Bock ("I", "me", or "my")
            collects, uses, and discloses information about you when you visit
            my website (katalinabock.com), contact me, or otherwise interact
            with me.
          </p>
          <p data-id="element-1394">
            I respect your privacy and am committed to protecting your personal
            data. This Privacy Policy will inform you about how I look after
            your personal data and tell you about your privacy rights.
          </p>
          <h2 data-id="element-1395">2. Information I Collect</h2>
          <p data-id="element-1396">I may collect the following types of information:</p>
          <ul data-id="element-1397">
            <li data-id="element-1398">
              <strong data-id="element-1399">Contact Information:</strong> When you fill out the
              contact form, I collect your name, email address, and any other
              information you provide in your message.
            </li>
            <li data-id="element-1400">
              <strong data-id="element-1401">Usage Data:</strong> I may collect information about how
              you use my website, including your IP address, browser type, pages
              visited, time spent on pages, and other browsing actions.
            </li>
            <li data-id="element-1402">
              <strong data-id="element-1403">Cookies and Similar Technologies:</strong> I use cookies
              and similar tracking technologies to track activity on my website
              and hold certain information.
            </li>
          </ul>
          <h2 data-id="element-1404">3. How I Use Your Information</h2>
          <p data-id="element-1405">
            I use the information I collect for various purposes, including to:
          </p>
          <ul data-id="element-1406">
            <li data-id="element-1407">Respond to your inquiries and communications</li>
            <li data-id="element-1408">Provide, maintain, and improve my website</li>
            <li data-id="element-1409">
              Monitor and analyze trends, usage, and activities in connection
              with my website
            </li>
            <li data-id="element-1410">Detect, prevent, and address technical issues</li>
            <li data-id="element-1411">Comply with legal obligations</li>
          </ul>
          <h2 data-id="element-1412">4. Sharing Your Information</h2>
          <p data-id="element-1413">I may share your information in the following situations:</p>
          <ul data-id="element-1414">
            <li data-id="element-1415">
              <strong data-id="element-1416">Service Providers:</strong> I may share your information
              with third-party vendors, service providers, contractors, or
              agents who perform services for me or on my behalf.
            </li>
            <li data-id="element-1417">
              <strong data-id="element-1418">Legal Requirements:</strong> I may disclose your
              information if required to do so by law or in response to valid
              requests by public authorities.
            </li>
            <li data-id="element-1419">
              <strong data-id="element-1420">Business Transfers:</strong> I may share or transfer your
              information in connection with, or during negotiations of, any
              merger, sale of assets, financing, or acquisition of all or a
              portion of my business.
            </li>
            <li data-id="element-1421">
              <strong data-id="element-1422">With Your Consent:</strong> I may disclose your personal
              information for any other purpose with your consent.
            </li>
          </ul>
          <h2 data-id="element-1423">5. Cookies Policy</h2>
          <p data-id="element-1424">
            Cookies are small data files that are placed on your computer or
            mobile device when you visit a website. I use cookies to enhance
            your experience on my website, analyze website traffic, and
            understand where my visitors are coming from.
          </p>
          <p data-id="element-1425">
            You can control cookies through your browser settings. However, if
            you block cookies, you may not be able to use all the features of my
            website.
          </p>
          <h2 data-id="element-1426">6. Data Security</h2>
          <p data-id="element-1427">
            I implement appropriate technical and organizational measures to
            protect the security of your personal information. However, please
            also remember that no method of transmission over the Internet or
            method of electronic storage is 100% secure.
          </p>
          <h2 data-id="element-1428">7. Your Data Protection Rights</h2>
          <p data-id="element-1429">
            Depending on your location, you may have the following rights
            regarding your personal data:
          </p>
          <ul data-id="element-1430">
            <li data-id="element-1431">The right to access, update, or delete your information</li>
            <li data-id="element-1432">
              The right to rectification (to correct or update your information)
            </li>
            <li data-id="element-1433">The right to object (to processing of your personal data)</li>
            <li data-id="element-1434">
              The right of restriction (to request that I restrict the
              processing of your data)
            </li>
            <li data-id="element-1435">
              The right to data portability (to receive a copy of your data)
            </li>
            <li data-id="element-1436">The right to withdraw consent</li>
          </ul>
          <p data-id="element-1437">
            If you wish to exercise any of these rights, please contact me
            through the contact information provided below.
          </p>
          <h2 data-id="element-1438">8. Children's Privacy</h2>
          <p data-id="element-1439">
            My website is not intended for children under 13 years of age. I do
            not knowingly collect personal information from children under 13.
            If you are a parent or guardian and you believe your child has
            provided me with personal information, please contact me.
          </p>
          <h2 data-id="element-1440">9. Changes to This Privacy Policy</h2>
          <p data-id="element-1441">
            I may update this Privacy Policy from time to time. I will notify
            you of any changes by posting the new Privacy Policy on this page
            and updating the "Last updated" date at the top of this Privacy
            Policy.
          </p>
          <p data-id="element-1442">
            You are advised to review this Privacy Policy periodically for any
            changes. Changes to this Privacy Policy are effective when they are
            posted on this page.
          </p>
          <h2 data-id="element-1443">10. Third-Party Links</h2>
          <p data-id="element-1444">
            My website may contain links to other websites that are not operated
            by me. If you click on a third-party link, you will be directed to
            that third party's site. I strongly advise you to review the Privacy
            Policy of every site you visit. I have no control over and assume no
            responsibility for the content, privacy policies, or practices of
            any third-party sites or services.
          </p>
          <h2 data-id="element-1445">11. Contact Information</h2>
          <p data-id="element-1446">
            If you have any questions about this Privacy Policy, please contact
            me via the{' '}
            <Link to="/contact" className="text-[#0096B4] hover:underline" data-id="element-1447">
              Contact page
            </Link>
            .
          </p>
        </div>
      </section>
    </div>;
}